import axiosInstance from "../../../interceptor/axiosInstance";
import {
  CHAPTER_CONTENTS,
  CHAPTER_CONTENTS_BULK,
} from "../../../routes/routeConstants/apiRoutes";
import { deserialize } from "serializr";
import Notification from "../../../shared/components/Notification";
import { NotificationTypes } from "../../../enums/notificationTypes";
import { ChapterContentModel } from "../../../models/CourseModels/ChapterModel/chapterContent.model";

export default class ChapterContentService {
  static getChapterContentsList(
    params: { chaptor_id: number },
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    return axiosInstance
      .get(CHAPTER_CONTENTS,{
        params
      })
      .then((response) => {
        const chapterContents = deserialize(
          ChapterContentModel,
          response.data["chaptor_contents"]
        );
        onSuccess(chapterContents);
      })
      .catch((error) => {
        Notification({
          message: "Failed",
          description: "Unable to fetch the chapter contents list",
          type: NotificationTypes.ERROR,
        });
        onError(error);
      })
      .finally(onFinal);
  }

  static addChapterContents(
    data: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    return axiosInstance
      .post(CHAPTER_CONTENTS_BULK, data)
      .then((response) => {
        const chapterContents = deserialize(
          ChapterContentModel,
          response.data["chaptor_contents"]
        );
        onSuccess(chapterContents);
      })
      .catch((error) => {
        Notification({
          message: "Failed",
          description: "Unable to create the chapter content",
          type: NotificationTypes.ERROR,
        });
        onError(error);
      })
      .finally(onFinal);
  }

  static updateChapterContent(
    id: string,
    data: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    return axiosInstance
      .put(CHAPTER_CONTENTS + `/${id}`, data)
      .then((response) => {
        const chapterContent = deserialize(
          ChapterContentModel,
          response.data["chaptor_content"]
        );
        onSuccess(chapterContent);
      })
      .catch((error) => {
        Notification({
          message: "Failed",
          description: "Unable to create the chapter content",
          type: NotificationTypes.ERROR,
        });
        onError(error);
      })
      .finally(onFinal);
  }

  static deleteChapterContent(
    id: string,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    return axiosInstance
      .delete(CHAPTER_CONTENTS + `/${id}`)
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        Notification({
          message: "Failed",
          description: "Unable to delete the chapter content",
          type: NotificationTypes.ERROR,
        });
        onError(error);
      })
      .finally(onFinal);
  }

  static updateChapterContentPosition(
    id: string,
    data: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    return axiosInstance
      .put(CHAPTER_CONTENTS + `/${id}/position`, data)
      .then((response) => {
        const chapterContent = deserialize(
          ChapterContentModel,
          response.data["chaptor_content"]
        );
        Notification({
          message: "Success",
          description:
            chapterContent?.displayTitle +
            " position has been updated successfully",
          type: NotificationTypes.SUCCESS,
        });
        onSuccess(chapterContent);
      })
      .catch((error) => {
        Notification({
          message: "Failed",
          description: "Unable to update the chapter content position",
          type: NotificationTypes.ERROR,
        });
        onError(error);
      })
      .finally(onFinal);
  }
}
